import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const tabsV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Tabs element to v2 by changing font style bold to font weight',
  run: (props: PartialPropsOf<'tabs'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props?.style?.font);
  },
};
